import { Record } from "immutable";

import createFromJS from "../../../createFromJS";
import { DateRecord } from "../../model/data/DateRecord";
import { TimespanRecord } from "../../model/data/TimespanRecord";

export const ValidatedConstraintRecord = Record({
  id: null,
  constraintType: null,
  subject: null,
  subjectTarget: null,
  object: null,
  objectTarget: null,
  comparison: null,
  date: DateRecord(),
  offset: TimespanRecord(),
  partPrecision: null,
  partValue: null,
  isViolated: false
});

const data = {
  objects: {
    offset: "TimespanRecord",
    date: "DateRecord"
  }
};
createFromJS.registerCallback(
  "ValidatedConstraintRecord",
  createFromJS.createNestedCallback(ValidatedConstraintRecord, data)
);
